document.addEventListener('DOMContentLoaded', () => {

    document.addEventListener('click', (event) => {
        const clickedStars = event.target.closest('.pr-snippet-stars .pr-rating-stars');
        const clickedCount = event.target.closest('.pr-snippet-read-and-write .pr-snippet-review-count');

        if (clickedStars || clickedCount) {
            const details = document.getElementById('reviews-accordion');
            const accordion = document.getElementById('displayReviews');
            
            if (details) details.open = true;
            if (accordion) {
                accordion.scrollIntoView({
                    behavior: 'smooth', 
                    block: 'start'
                });
            }
        }
    });

    const manageReviewVisibility = () => {
        const noReviewsElement = document.querySelector('.pr-no-reviews');
        const hasBrandScore = document.querySelector('.pr-review-snapshot-brandscore');
        const displayReviews = document.getElementById('displayReviews');

        if (!displayReviews) return; 
        if (noReviewsElement && !hasBrandScore) {
            displayReviews.style.display = 'none';
        } else {
            displayReviews.style.display = ''; 
        }
    };
    manageReviewVisibility();

    const observer = new MutationObserver(manageReviewVisibility);
    observer.observe(document.body, { 
        childList: true, 
        subtree: true 
    });
});

document.addEventListener('mousedown', function(event) {
    // Select the modal content and the close button
    const modalContent = document.querySelector('.pr-media-card');
    const closeButton = document.querySelector('.button__close');

    // Check if the user clicked the "Next" button or anything inside it
    const isNextButtonClick = event.target.closest('.button__next');
    const isPrevButtonClick = event.target.closest('.button__prev');
    
    // 1. Check if the modal content exists in the DOM
    // 2. Check if the click target is NOT inside the modal content
    if (modalContent && !modalContent.contains(event.target) && !isNextButtonClick && !isPrevButtonClick) {
        
        // 3. If the close button exists, trigger its click event
        if (closeButton) {
            closeButton.click();
        }
    }
});